(function () {
  function setupInventory(root) {
    var form = root.querySelector('[data-inventory-filter]');
    if (!form) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vehicle-card]'));
    var brandSelect = root.querySelector('[data-filter-brand]');
    var priceSelect = root.querySelector('[data-filter-price]');
    var count = root.querySelector('[data-result-count]');
    var empty = root.querySelector('[data-empty-state]');
    var availabilityButtons = Array.prototype.slice.call(root.querySelectorAll('[data-filter-availability]'));
    var availability = '';

    function applyFilters() {
      var brand = brandSelect ? brandSelect.value : '';
      var maxPrice = priceSelect && priceSelect.value ? Number(priceSelect.value) : Infinity;
      var visible = 0;

      cards.forEach(function (card) {
        var matchesBrand = !brand || card.dataset.brand === brand;
        var matchesPrice = maxPrice === Infinity || (card.dataset.priceMode !== 'quote' && card.dataset.price !== '' && Number(card.dataset.price) <= maxPrice);
        var matchesAvailability = !availability || card.dataset.availability === availability;
        var show = matchesBrand && matchesPrice && matchesAvailability;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = visible + (visible === 1 ? ' vehículo' : ' vehículos');
      if (empty) empty.hidden = visible !== 0;
      availabilityButtons.forEach(function (button) {
        button.classList.toggle('active', button.dataset.filterAvailability === availability);
        button.setAttribute('aria-pressed', button.dataset.filterAvailability === availability ? 'true' : 'false');
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
    });

    availabilityButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        availability = button.dataset.filterAvailability || '';
        applyFilters();
      });
    });

    var clear = root.querySelector('[data-clear-filters]');
    if (clear) clear.addEventListener('click', function () {
      availability = '';
      if (brandSelect) brandSelect.value = '';
      if (priceSelect) priceSelect.value = '';
      applyFilters();
    });

    applyFilters();
  }

  document.querySelectorAll('[data-inventory-root]').forEach(setupInventory);

  document.querySelectorAll('.mobile-menu a').forEach(function (link) {
    link.addEventListener('click', function () {
      var menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });
})();
